$(document).ready(function () {
  $(window).scroll(function () {
    if ($(document).scrollTop() > 50) {
      $(".header-nav").addClass("test");
          $(".sub-header").addClass("test");
    } else {
      $(".header-nav").removeClass("test");
      $(".sub-header").removeClass("test");
    }
  });
});

$(".review-slider").owlCarousel({
  loop: true,
  margin: 10,
  mouseDrag: false,
  nav: true,
  dots: false,
  navText: [
    "<i class='fal fa-long-arrow-left'></i>",
    "<i class='fal fa-long-arrow-right'></i>",
  ],
  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 1,
    },
    1000: {
      items: 1,
    },
  },
});

$(".coaches-sec-slider").owlCarousel({
  loop: true,
  margin: 50,
  nav: true,
  items: 4,
  slideBy: 4,
  loop: true,
  dots: false,
  navText: [
    "<i class='fal fa-long-arrow-left'></i>",
    "<i class='fal fa-long-arrow-right'></i>",
  ],
  responsive: {
    0: {
      items: 1,
    },
    420: {
      items: 2,
    },
    767: {
      items: 3,
    },
    1199: {
      items: 4,
    },
  },
});

$(document).ready(function () {
  var $parent, windowWidth, windowHeight;

  //get actual window size
  function winSize() {
    (windowWidth = $(window).width()), (windowHeight = $(window).height());
  }
  winSize();
  $(window).resize(winSize);
  //tooltip fadeIn and fadeOut on hover
  $(".tooltip-box").each(function () {
    $(this)
      .parent()
      .hover(
        function () {
          $(this).find(".tooltip-box").fadeIn("fast");
        },
        function () {
          $(this).find(".tooltip-box").fadeOut("fast");
        }
      );
  });

  //tooltip position
  $(document).mousemove(function (e) {
    var mouseY = e.clientY,
      mouseX = e.clientX,
      tooltipHeight,
      tooltipWidth;

    $(".tooltip-box").each(function () {
      var $tooltip = $(this);
      tooltipHeight = $tooltip.outerHeight();
      tooltipWidth = $tooltip.width();
      $parent = $tooltip.parent();

      $tooltip.css({
        left: mouseX,
        top: mouseY + 20,
        // 'display': block
      });

      //reposition
      if (tooltipWidth + mouseX + 20 > windowWidth) {
        $tooltip.css({
          left: mouseX - tooltipWidth - 20,
        });
      }

      if (tooltipHeight + mouseY + 20 > windowHeight) {
        $tooltip.css({
          top: mouseY - 20 - tooltipHeight,
        });
      }
    }); //end each
  }); //tooltip position

  $(".drag").draggable();
});

$(".flykit-review-slider").owlCarousel({
  loop: true,
  margin: 10,
  mouseDrag: false,
  nav: true,
  dots: false,
  navText: [
    "<i class='fal fa-long-arrow-left'></i>",
    "<i class='fal fa-long-arrow-right'></i>",
  ],
  responsive: {
    0: {
      items: 1,
    },
    600: {
      items: 1,
    },
    1000: {
      items: 1,
    },
  },
});

